import { NavLink } from "react-router-dom";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const Wrapper = styled.nav`
    border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
`;

export const LinkTabsUL = styled.ul`
    display: flex;
    margin: 0 0 -1px;
    padding: 0;
`;

export const LinkTabsLI = styled.li`
    list-style: none;
`;

export const TabList = styled(NavLink)`
    display: inline-flex;
    text-decoration: none;
    padding: 16px;
    gap: 4px;
    align-items: center;
    background: ${COLOR_VALUES.White};
    color: ${COLOR_VALUES.Gray_4} !important; /* !important to override css reboot */
    text-decoration: none !important; /* !important to override css reboot */
    cursor: pointer;

    &:hover {
        background: ${COLOR_VALUES.Gray_8};
        border-bottom: 2px solid ${COLOR_VALUES.Gray_6};
    }

    &.active {
        color: ${COLOR_VALUES.Black} !important; /* !important to override css reboot */
        border-bottom: 2px solid ${COLOR_VALUES.Black};
    }
`;
